import { Routes } from '@angular/router';
import { LayoutComponent } from './web/layout/layout.component';
import { content } from './web/shared/routes/routes';
import { AuthComponent } from './web/components/auth/auth.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'auth',
        component: AuthComponent,
        // children: content
    },    
    {
        path: '',
        component: LayoutComponent,
        children: content
    },  
];

